export enum IboSearchType {
    ibo = 'ibo',
    mobile = 'mobile',
    email = 'email',
    name = 'name'
}